import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Switch } from "react-router-dom";

import { CustomerRoute, PrivateRoute } from "helper/route";
import LayoutContainer from "containers/Layout";

// pages
import Overview from "pages/Customer/Overview";
import Payment from "pages/Customer/Payment";
import Broker from "pages/Customer/Broker";
import DocumentSigning from "pages/Customer/DocumentSigning";
import Refer from "pages/Customer/Refer";
import ProductList from "pages/Customer/ProductList";
import JarvisInfo from "pages/Customer/JarvisInfo";
import SubscriptionPayment from "pages/Customer/SubscriptionPayment";
import PlanAndPricing from "pages/PlanAndPricing";
import HelpSupport from "containers/HelpSupport";
import OneTimePayment from "pages/Customer/OneTimePayment";
import AllInOneRoutes from "navigator/AllInOneRoutes";
import ProductInfoRoutes from "navigator/ProductInfoRoutes";

const CustomerNavigator = (props) => {
  const { match } = props;
  const isAuthenticated = useSelector(
    (state) => state.customer.isAuthenticated,
  );

  // Product onboaridng completed
  const isPortfolioOnboardingCompleted = useSelector(
    (state) => state.onboarding.isOnboardingCompleted,
  );
  const isRMSonboardingCompleted = useSelector(
    (state) => state.jarvisRMS.rmsOnboarding.isOnboardingCompleted,
  );
  const isOnestockonboardingCompleted = useSelector(
    (state) => state.jarvisOnestock.onestockOnboarding.isOnboardingCompleted,
  );
  const isPrimeonboardingCompleted = useSelector(
    (state) => state.jarvisPrime.primeOnboarding.isPrimeOnboardingCompleted,
  );
  const isSentimentTrackerOnboardingCompleted = useSelector(
    (state) =>
      state.sentimentTracker.sentimentTrackerOnboarding.isOnboardingCompleted,
  );

  const isPhcOnboardingCompleted = useSelector(
    (state) => state.PHC.PHCOnboarding.isOnboardingCompleted,
  );

  const anyOnboardingCompleted =
    isPortfolioOnboardingCompleted ||
    isRMSonboardingCompleted ||
    isOnestockonboardingCompleted ||
    isPrimeonboardingCompleted ||
    isSentimentTrackerOnboardingCompleted ||
    isPhcOnboardingCompleted;

  return (
    <Switch>
      {/* 1 - Redirection to */}
      <Redirect exact from={match.path} to={`${match.path}/profile`} />
      {/* Legacy App More → All-In-One Profile */}
      <Redirect
        exact
        from={`${match.path}/app-more`}
        to={`${match.path}/profile`}
      />

      <LayoutContainer {...props}>
        <Switch>
          {/* 2 -  Without layout pages */}
          {/* for first visit customer */}
          <PrivateRoute
            exact
            auth={{ isAuthenticated }}
            path={`${match.path}/jarvis-info`}
            component={JarvisInfo}
          />

          {/* Shared AllInOneLayout — nav stays mounted across these routes */}
          <PrivateRoute
            auth={{ isAuthenticated }}
            path={[
              `${match.path}/dashboard`,
              `${match.path}/holdings`,
              `${match.path}/market-pulse`,
              `${match.path}/blogs`,
              `${match.path}/profile`,
            ]}
            render={() => (
              <AllInOneRoutes
                match={match}
                isAuthenticated={isAuthenticated}
                isOnboardingCompleted={anyOnboardingCompleted}
              />
            )}
          />

          {/* Product info pages: /customer/product-info/:product */}
          <PrivateRoute
            auth={{ isAuthenticated }}
            path={`${match.path}/product-info`}
            render={(routeProps) => (
              <ProductInfoRoutes
                match={routeProps.match}
                isAuthenticated={isAuthenticated}
              />
            )}
          />

          <PrivateRoute
            exact
            auth={{ isAuthenticated }}
            path={`${match.path}/product-list`}
            component={ProductList}
          />

          {/* Routes accessible for onboarding and customer */}
          <PrivateRoute
            exact
            auth={{ isAuthenticated }}
            path={`${match.path}/broker`}
            component={Broker}
          />
          <PrivateRoute
            exact
            auth={{ isAuthenticated }}
            path={`${match.path}/document-signing`}
            component={DocumentSigning}
          />
          <PrivateRoute
            exact
            auth={{ isAuthenticated }}
            path={`${match.path}/subscription`}
            component={SubscriptionPayment}
          />
          <PrivateRoute
            exact
            auth={{ isAuthenticated }}
            path={`${match.path}/payment`}
            component={Payment}
          />
          <PrivateRoute
            exact
            auth={{ isAuthenticated }}
            path={`${match.path}/onetime-payment`}
            component={OneTimePayment}
          />

          {/* 3 - With layout pages */}
          <CustomerRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={anyOnboardingCompleted}
            path={`${match.path}/overview`}
            component={Overview}
          />
          <CustomerRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={anyOnboardingCompleted}
            path={`${match.path}/refer-jarvis`}
            component={Refer}
          />
          <CustomerRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={anyOnboardingCompleted}
            path={`${match.path}/help-support`}
            component={HelpSupport}
          />
          <CustomerRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={anyOnboardingCompleted}
            path={`${match.path}/plan-and-pricing`}
            component={PlanAndPricing}
          />
        </Switch>
      </LayoutContainer>

      <Redirect to={`not-found`} />
    </Switch>
  );
};

export default CustomerNavigator;
